module.exports = {"450108001":"大沙田街道","450108002":"玉洞街道","450108100":"良庆镇","450108101":"那马镇","450108102":"那陈镇","450108103":"大塘镇","450108104":"南晓镇","450108452":"良庆经济开发区管委会"}


//////////////////
// WEBPACK FOOTER
// ./src/town/450108.json
// module id = 2073
// module chunks = 0